import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCode = styled.code.withConfig({
  displayName: "Code__StyledCode"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const Code = _ref => {
  let {
      children
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledCode, Object.assign({}, domProps, callbackProps, {
    $cssStyles: cssStyles,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'Code',
    children: children
  }));
};
Code.displayName = 'Code';